import type { TranslationKey } from '../../i18n/index.js';

/**
 * Firebase Auth failures as something a person can act on (doc 88 D12).
 *
 * The sign-in screen used to show Firebase's own message text. With email
 * forms that text would reach every user, in English, and some of it names
 * internals. Codes we expect get our wording; anything else gets a generic
 * line — never the raw message.
 *
 * `auth/invalid-credential` covers both a wrong password and an unknown
 * address: with email enumeration protection on, Firebase does not say which,
 * and neither do we.
 */
const BY_CODE: Record<string, TranslationKey> = {
  'auth/invalid-credential': 'authError.invalidCredential',
  'auth/wrong-password': 'authError.invalidCredential',
  'auth/user-not-found': 'authError.invalidCredential',
  'auth/invalid-login-credentials': 'authError.invalidCredential',
  'auth/invalid-email': 'authError.invalidEmail',
  'auth/missing-email': 'authError.invalidEmail',
  'auth/email-already-in-use': 'authError.emailInUse',
  'auth/weak-password': 'authError.weakPassword',
  'auth/missing-password': 'authError.weakPassword',
  'auth/too-many-requests': 'authError.tooManyRequests',
  'auth/network-request-failed': 'authError.network',
  'auth/expired-action-code': 'authError.linkExpired',
  'auth/invalid-action-code': 'authError.linkInvalid',
  'auth/user-disabled': 'authError.disabled',
  'auth/popup-blocked': 'authError.popupBlocked',
};

export function authErrorKey(error: unknown): TranslationKey {
  const code = (error as { code?: string } | null)?.code;
  return (code && BY_CODE[code]) || 'authError.generic';
}
